import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { useSettings } from "@/lib/settings";

export default function AdminSettings() {
  const { refresh } = useSettings();
  const [form, setForm] = useState(null);

  useEffect(() => { api.get("/settings").then(r => setForm(r.data)); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/settings", form);
      await refresh();
      toast.success("Saved");
    } catch { toast.error("Save failed"); }
  };

  if (!form) return <div>Loading…</div>;
  const fields = [
    { name: "business_name", label: "Business Name" },
    { name: "tagline", label: "Tagline" },
    { name: "phone", label: "Phone" },
    { name: "email", label: "Email" },
    { name: "address", label: "Address" },
    { name: "facebook", label: "Facebook URL" },
    { name: "instagram", label: "Instagram URL" },
    { name: "tiktok", label: "TikTok URL" },
    { name: "whatsapp", label: "WhatsApp URL" },
  ];
  return (
    <div data-testid="admin-settings">
      <h1 className="font-display text-3xl text-[color:var(--color-primary)] mb-8">Settings</h1>
      <form onSubmit={save} className="bg-white border border-[color:var(--color-border)] rounded p-6 space-y-4 max-w-2xl">
        {fields.map((f) => (
          <div key={f.name}>
            <label className="text-xs uppercase tracking-widest text-gray-600">{f.label}</label>
            <input value={form[f.name] || ""} onChange={(e) => setForm({ ...form, [f.name]: e.target.value })} className="w-full mt-1 border border-[color:var(--color-border)] rounded px-3 py-2" data-testid={`setting-${f.name}`}/>
          </div>
        ))}
        <button type="submit" className="btn-primary" data-testid="settings-save">Save</button>
      </form>
    </div>
  );
}
